import { Box, BoxProps, styled } from '@mui/material';

export const StyledBox = styled(Box)<Partial<BoxProps>>`
    position: absolute;
    color: white;
    pointer-events: all;
    display: flex;
    flex-direction: column;

    &.isDraggable {
        cursor: pointer;
    }

    &.isScheduledOrActual {
        opacity: 50%;
    }
`;
